module.exports = __webpack_public_path__ + "static/media/timeline-inactive.768957ba.svg";